<h2 class="complete-profile-title">
  <button class="cursor-pointer hover:text-primary" (click)="onBack.emit()"><i class="fa-light fa-square-arrow-left text-3xl"></i></button>
  Tell Us More
</h2>
<form (submit)="submitForm($event)" novalidate appAutoValidate>
  <div class="grid grid-cols-1 gap-4">
    <div class="form-group">
      <label for="">Relationship Status</label>
      <app-select-field [options]="attributeService.attributes().relationship_status" [formField]="form.relationship_status"></app-select-field>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

      <div class="form-group">
        <label for="">Religion</label>
        <app-select-field [options]="attributeService.attributes().religion" [formField]="form.religion"></app-select-field>
      </div>
      <div class="form-group">
        <label for="">Caste</label>
        <app-select-field [options]="attributeService.attributes().caste" [formField]="form.caste"></app-select-field>
      </div>
    </div>
    <div class="form-group">
      <label for="">Diet</label>
      <app-select-field [options]="attributeService.attributes().diet" [formField]="form.diet"></app-select-field>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="form-group">
        <label for="">Smoking Habit</label>
        <app-select-field [options]="attributeService.attributes().smoking_habit" [formField]="form.smoking_habit"></app-select-field>
      </div>
      <div class="form-group">
        <label for="">Drinking Habit</label>
        <app-select-field [options]="attributeService.attributes().drinking_habit" [formField]="form.drinking_habit"></app-select-field>
      </div>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="form-group">
        <label for="">Education</label>
        <app-select-field [options]="attributeService.attributes().education" [formField]="form.education"></app-select-field>
      </div>
      <div class="form-group">
        <label for="">Occupation</label>
        <app-select-field [options]="attributeService.attributes().occupation" [formField]="form.occupation"></app-select-field>
      </div>
    </div>

  </div>
  <button [disabled]="form().invalid()" class="mt-6 btn-base bg-primary text-white w-full ">
    @if (loading()) {
      <i class="fa fa-spinner"></i>
    }
    {{ standalone() ? 'Save' : 'Next' }}
  </button>
</form>
